module.exports = __webpack_public_path__ + "static/img/bg.32f8e0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = yRcn
// module chunks = 3